export const EXTERIOR_RESOURCES = {
  Helicoptero3D: { type: 'glb', url: './models/ext/Joby_Update_animations_15x.glb' },
  Environment: { type: 'exr', url: '/images/experiences/ext/citrus_orchard_road_puresky_1k.exr' },
  SonidoHelicoptero: { type: 'audio', url: 'audio/helicopterLoop.wav' },
  ImgTapToStart: { type: 'image', url: '/images/experiences/ext/tap_still.webp' },
  ImgSwipeToRotate: { type: 'image', url: '/images/experiences/ext/swipe_rotate.webp' },
  ImgPinchToZoom: { type: 'image', url: '/images/experiences/ext/pinch_zoom.webp' },
};

export const INTERIOR_RESOURCES = {
  TexturaInterior: { type: 'image', url: '/images/experiences/int/jobyInt02.png' },
  VideoDespegue: { type: 'video', url: '/videos/despegue-V4.webm' },
  VideoVuelo: { type: 'video', url: '/videos/vuelo-V4.webm' },
  SonidoHelicoptero: { type: 'audio', url: 'audio/helicopterLoop.wav' },
  ImgHotspot1: { type: 'image', url: '/images/experiences/int/hotspot1.webp' },
  ImgHotspot2: { type: 'image', url: '/images/experiences/int/hotspot2.webp' },
  ImgHotspot3: { type: 'image', url: '/images/experiences/int/hotspot3.webp' },
  ImgHotspot4: { type: 'image', url: '/images/experiences/int/hotspot4.webp' },
  ImgHotspot5: { type: 'image', url: '/images/experiences/int/hotspot5.webp' },
};
